import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`

export const HeadContainer = styled.div`
  display: flex;
  justify-content: space-between;
`

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export const SearchWrapper = styled.div`
  display: flex;
  gap: ${theme.spacing.sm};
  align-items: flex-end;
`

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${theme.colors.quartenary};
  margin: ${theme.spacing.md} 0;
`

export const ActionRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const TableWrapper = styled.div`
  display: grid;
  width: 100%;
`

export const EmptyValue = styled.div`
  opacity: 0.2;
`

export const SummaryWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${theme.spacing.xm};
  margin-top: ${theme.spacing.md};
  flex-wrap: wrap-reverse;
`

export const SummaryRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: ${theme.spacing.lg};

  @media (max-width: ${theme.breakpoints.lg}px) {
    width: 100%;
  }
`

export const SummaryItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`

export const LoadingContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  border-radius: ${theme.shapes.borderRadius.sm};
  background-color: ${theme.colors.neutral['100']};
  height: 312px;
`

export const FilterButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  outline: none;
  width: 40px;
  height: 40px;
  border-radius: ${theme.shapes.borderRadius.sm};
  background-color: ${theme.colors.neutral.white};
  transition: background 0.2s ease-in-out;
  cursor: pointer;

  svg {
    path {
      fill: ${theme.colors.primary.main};
    }
  }

  :hover {
    background-color: ${theme.colors.neutral.clear};
  }

  :disabled {
    cursor: not-allowed;
    background-color: ${theme.colors.neutral['100']};
  }
`

export const CheckboxRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.xm};
`

export const CheckboxList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.xs};
`

export const ModalActionsRow = styled.div`
  display: flex;
  width: 100%;
  gap: ${theme.spacing.sm};
  justify-content: flex-end;

  button {
    height: 40px;
  }
`

export const FilterOption = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: ${theme.spacing.md};

  > span {
    color: ${theme.colors.neutral.high};
    font-size: ${theme.typography.sizes.sm};
    font-family: ${theme.typography.family.bold};
  }
`

export const FilterButtonWrapper = styled.div`
  width: ${theme.spacing.xl};
  height: ${theme.spacing.xl};
`

export const FiltersNumberStyled = styled.div`
  pointer-events: none;
  background-color: ${theme.colors.neutral.white};
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  position: relative;
  top: -38px;
  left: 21px;
  font-size: ${theme.typography.sizes['2xs']};
  font-family: ${theme.typography.family.bold};
  color: ${theme.colors.primary.main};
  border-radius: ${theme.shapes.borderRadius.full};
  border: 2px solid ${theme.colors.primary.main};
  height: 15px;
  width: 15px;
`

export const IconSpan = styled.span`
  display: flex;
  gap: ${theme.spacing.xs};
`

export const NotFoundWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 320px;
  background-color: ${theme.colors.neutral[100]};
  border-radius: ${theme.shapes.borderRadius.md};
  margin: ${theme.spacing.xs} 0;
`

export const NotFoundContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${theme.spacing.md};
  width: 100%;
`
